import Vue from "vue"
import Router from "vue-router"
import DashboardLayout from "../layouts/DashboardLayout.vue"
import LoginView from "../views/LoginView.vue"
import DashboardView from "../views/DashboardView.vue"
import BannerSettingsView from "../views/BannerSettingsView.vue"
import StartupSettingsView from "../views/StartupSettingsView.vue"
import NoticeManageView from "../views/NoticeManageView.vue"
import SquareTagManageView from "../views/SquareTagManageView.vue"
import ActivityConfigView from "../views/ActivityConfigView.vue"
import UserListView from "../views/UserListView.vue"
import FeedbackManageView from "../views/FeedbackManageView.vue"
import PetListView from "../views/PetListView.vue"
import PetTypeCatalogView from "../views/PetTypeCatalogView.vue"
import FeedingPlanView from "../views/FeedingPlanView.vue"
import PlanManagementView from "../views/PlanManagementView.vue"
import FeedingRecordView from "../views/FeedingRecordView.vue"
import HealthRecordView from "../views/HealthRecordView.vue"
import EnvironmentRecordView from "../views/EnvironmentRecordView.vue"
import AgentWorkflowView from "../views/AgentWorkflowView.vue"
import ProductReviewView from "../views/ProductReviewView.vue"
import ActivityLotteryView from "../views/ActivityLotteryView.vue"
import InviteCodeView from "../views/InviteCodeView.vue"
import PointsExchangeView from "../views/PointsExchangeView.vue"
import ContentAuditView from "../views/ContentAuditView.vue"
import SquareManageView from "../views/SquareManageView.vue"
import CreatorManageView from "../views/CreatorManageView.vue"
import SimulationView from "../views/SimulationView.vue"
import AppThemeView from "../views/AppThemeView.vue"
import AboutView from "../views/AboutView.vue"
import AiImageManagerView from "../views/AiImageManagerView.vue"
import CompanyProjectsView from "../views/CompanyProjectsView.vue"
import OfficeRectificationView from "../views/OfficeRectificationView.vue"
import MachineLearningView from "../views/MachineLearningView.vue"
import AdminAccountsView from "../views/AdminAccountsView.vue"
import AdminRolesView from "../views/AdminRolesView.vue"
import MerchantAccountsView from "../views/MerchantAccountsView.vue"
import PlatformPayView from "../views/PlatformPayView.vue"
import MembershipConfigView from "../views/MembershipConfigView.vue"
import MembershipOrdersView from "../views/MembershipOrdersView.vue"
import SupplierSettlementView from "../views/SupplierSettlementView.vue"
import PlatformServiceView from "../views/PlatformServiceView.vue"
import ShopCouponView from "../views/ShopCouponView.vue"
import ChangePasswordView from "../views/ChangePasswordView.vue"
import AccessDeniedView from "../views/AccessDeniedView.vue"
import { getAdminUser, hasAdminPermission } from "../utils/adminSession"

Vue.use(Router)

const router = new Router({
  mode: "hash",
  routes: [
    {
      path: "/login",
      name: "login",
      component: LoginView
    },
    {
      path: "/change-password",
      name: "changePassword",
      component: ChangePasswordView
    },
    {
      path: "/access-denied",
      name: "accessDenied",
      component: AccessDeniedView
    },
    {
      path: "/",
      component: DashboardLayout,
      redirect: "/dashboard",
      children: [
        {
          path: "dashboard",
          name: "dashboard",
          component: DashboardView,
          meta: { title: "工作台", permission: "dashboard:view" }
        },
        {
          path: "banner-settings",
          name: "bannerSettings",
          component: BannerSettingsView,
          meta: { title: "轮播图设置", permission: "operation:banner" }
        },
        {
          path: "startup-settings",
          name: "startupSettings",
          component: StartupSettingsView,
          meta: { title: "启动页设置", permission: "operation:theme" }
        },
        {
          path: "notices",
          name: "notices",
          component: NoticeManageView,
          meta: { title: "爬仔团队", permission: "operation:notice" }
        },
        {
          path: "square-tags",
          name: "squareTags",
          component: SquareTagManageView,
          meta: { title: "广场标签", permission: "operation:square_topic" }
        },
        {
          path: "users",
          name: "users",
          component: UserListView,
          meta: { title: "用户管理", permission: "users:view" }
        },
        {
          path: "feedbacks",
          name: "feedbacks",
          component: FeedbackManageView,
          meta: { title: "问题反馈", permission: "feedback:view" }
        },
        {
          path: "pets",
          name: "pets",
          component: PetListView,
          meta: { title: "宠物资料", permission: "pets:view" }
        },
        {
          path: "pet-types",
          name: "petTypes",
          component: PetTypeCatalogView,
          meta: { title: "宠物类型", permission: "catalog:view" }
        },
        {
          path: "feeding-plans",
          name: "feedingPlans",
          component: FeedingPlanView,
          meta: { title: "喂食计划模板", permission: "operation:feeding" }
        },
        {
          path: "plan-management",
          name: "planManagement",
          component: PlanManagementView,
          meta: { title: "计划管理", permission: "operation:feeding" }
        },
        {
          path: "feeding-records",
          name: "feedingRecords",
          component: FeedingRecordView,
          meta: { title: "投喂记录", permission: "pets:view" }
        },
        {
          path: "health-records",
          name: "healthRecords",
          component: HealthRecordView,
          meta: { title: "健康观察", permission: "pets:view" }
        },
        {
          path: "environment-records",
          name: "environmentRecords",
          component: EnvironmentRecordView,
          meta: { title: "环境记录", permission: "pets:view" }
        },
        {
          path: "agent-workflows",
          name: "agentWorkflows",
          component: AgentWorkflowView,
          meta: { title: "Agent 流程编排", permission: "agent:workflow" }
        },
        {
          path: "product-reviews",
          name: "productReviews",
          component: ProductReviewView,
          meta: { title: "商品发布审核", permission: "operation:shop_review" }
        },
        {
          path: "activity-lottery",
          name: "activityLottery",
          component: ActivityLotteryView,
          meta: { title: "抽奖活动", permission: "activity:view" }
        },
        {
          path: "activity-config",
          name: "activityConfig",
          component: ActivityConfigView,
          meta: { title: "活动配置", permission: "activity:review" }
        },
        {
          path: "invite-codes",
          name: "inviteCodes",
          component: InviteCodeView,
          meta: { title: "邀请码管理", permission: "activity:view" }
        },
        {
          path: "points-exchanges",
          name: "pointsExchanges",
          component: PointsExchangeView,
          meta: { title: "积分兑换", permission: "activity:view" }
        },
        {
          path: "content-audits",
          name: "contentAudits",
          component: ContentAuditView,
          meta: { title: "内容审核管理", permission: "content:audit:view" }
        },
        {
          path: "square-manage",
          name: "squareManage",
          component: SquareManageView,
          meta: { title: "广场管理", permission: "square:manage" }
        },
        {
          path: "creator-manage",
          name: "creatorManage",
          component: CreatorManageView,
          meta: { title: "达人管理", permission: "operation:creator" }
        },
        {
          path: "simulation",
          name: "simulation",
          component: SimulationView,
          meta: { title: "模拟互动", permission: "simulation:manage" }
        },
        {
          path: "app-themes",
          name: "appThemes",
          component: AppThemeView,
          meta: { title: "主题换肤", permission: "operation:theme" }
        },
        {
          path: "about",
          name: "about",
          component: AboutView,
          meta: { title: "关于我们", permission: "operation:theme" }
        },
        {
          path: "ai-images",
          name: "aiImages",
          component: AiImageManagerView,
          meta: { title: "生图管理", permission: "operation:ai_image" }
        },
        {
          path: "company-projects",
          name: "companyProjects",
          component: CompanyProjectsView,
          meta: { title: "公司项目", permission: "office:design:view" }
        },
        {
          path: "design-deliveries",
          redirect: "/company-projects"
        },
        {
          path: "office-rectification",
          name: "officeRectification",
          component: OfficeRectificationView,
          meta: { title: "整改事项", permission: "office:rectification:view" }
        },
        {
          path: "machine-learning",
          name: "machineLearning",
          component: MachineLearningView,
          meta: { title: "机器学习", permission: "office:ml:view" }
        },
        {
          path: "admin-accounts",
          name: "adminAccounts",
          component: AdminAccountsView,
          meta: { title: "内部账号", permission: "system:account:view" }
        },
        {
          path: "admin-roles",
          name: "adminRoles",
          component: AdminRolesView,
          meta: { title: "角色权限", permission: "system:role:view" }
        },
        {
          path: "merchant-accounts",
          name: "merchantAccounts",
          component: MerchantAccountsView,
          meta: { title: "商户账号", permission: "operation:merchant_account:edit" }
        },
        {
          path: "platform-pay",
          name: "platformPay",
          component: PlatformPayView,
          meta: { title: "支付配置", permission: "operation:platform_pay:edit" }
        },
        {
          path: "membership-config",
          name: "membershipConfig",
          component: MembershipConfigView,
          meta: { title: "会员套餐", permission: "operation:membership:edit" }
        },
        {
          path: "membership-orders",
          name: "membershipOrders",
          component: MembershipOrdersView,
          meta: { title: "会员订单", permission: "operation:membership:edit" }
        },
        {
          path: "supplier-settlements",
          name: "supplierSettlements",
          component: SupplierSettlementView,
          meta: { title: "供应商结款", permission: "operation:membership:edit" }
        },
        {
          path: "platform-service",
          name: "platformService",
          component: PlatformServiceView,
          meta: { title: "平台客服" }
        }
        ,
        {
          path: "shop-coupons",
          name: "shopCoupons",
          component: ShopCouponView,
          meta: { title: "平台优惠券" }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("admin_token")
  const user = getAdminUser()
  if (to.path === "/login") {
    if (token && user) return next(user.mustChangePassword ? "/change-password" : "/dashboard")
    return next()
  }
  if (!token || !user) return next({ path: "/login", query: { redirect: to.fullPath } })
  if (user.mustChangePassword && to.path !== "/change-password") return next("/change-password")
  if (!user.mustChangePassword && to.path === "/change-password") return next("/dashboard")
  if (to.meta.permission && !hasAdminPermission(to.meta.permission)) return next("/access-denied")
  next()
})

export default router
